module.exports = __webpack_public_path__ + "OpenSans-LightItalic.a185d6972722f9a48ed5.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-LightItalic.ttf
// module id = ../../../../../src/assets/customfonts/OpenSans-LightItalic.ttf
// module chunks = styles